import { KeyedWord } from '../../../main/types/asset/word.types.ts';

import { mapRegularLetterAppearance } from '../../mappers/regular-letter-appearance.mapper.ts';

import { BaseClickHandler } from './base-click-handler.util.ts';

export class TappableStoryWordUtil extends BaseClickHandler<KeyedWord, string> {
  private static _instance: TappableStoryWordUtil;

  public static get instance(): TappableStoryWordUtil {
    if (!TappableStoryWordUtil._instance) {
      TappableStoryWordUtil._instance = new TappableStoryWordUtil();
    }
    return TappableStoryWordUtil._instance;
  }

  protected override processInput(word: KeyedWord): string {
    const normalizedWord = word.appearance
      .map((letter) => letter.toLowerCase())
      .map(mapRegularLetterAppearance)
      .join('')
      .replace(/[^a-z']/g, '');

    return normalizedWord;
  }
}

export const getTappableStoryWordUtil = (): TappableStoryWordUtil => TappableStoryWordUtil.instance;
